import React from 'react';
import '../../less/bootstrap.less'
import '../../assets/css/fontawe.css'
import './HeaderInvoiceList.css'
import { dollarNumber, centNumber } from '../../utils/Currency'
import { HeaderInvoiceError, HeaderInvoiceLoading } from './HeaderInvoice'
import { invoiceListErrorPage } from './InvoiceListErrorPage';
import './HeaderInvoiceList.css'

export type HeaderInvoiceListProps = {
    readonly loading: boolean
    readonly error: boolean
    readonly showListPage: boolean
    readonly isStatement: boolean
    readonly isPaymentPage: boolean
    readonly recording: boolean
    readonly invoicesToPay?: number
    readonly invoiceList: any
    readonly totalDue: any
    readonly isTimedOut: boolean
    readonly bulkPaymentError: boolean
    readonly fsPlatformError: boolean
}

export default class HeaderInvoiceList extends React.Component<HeaderInvoiceListProps> {
    render() {
        const {
            loading,
            error,
            recording,
            invoiceList,
            isPaymentPage,
            isTimedOut,
            bulkPaymentError
        } = this.props;
        const ieVersion9 = !!document['documentMode'] && document['documentMode'] === 9;

        if (loading) {
            return <HeaderInvoiceLoading />;
        }
        if (error) {
            return <HeaderInvoiceError />;
        }
        if (bulkPaymentError) {
            return (
                <div id="stickySource">
                    {this.renderHeaderTop(ieVersion9)}
                    {this.renderMobileHeaderTop()}
                </div>
            );
        }
        if (!recording) {
            return (
                <div id="stickySource">
                    {this.renderHeaderTop(ieVersion9)}
                    {this.renderMobileHeaderTop()}
                    {!isPaymentPage && invoiceListErrorPage(invoiceList, isTimedOut)}
                    {this.renderInvoiceListHeader()}
                </div>
            );
        }
    }

    renderHeaderTop(ieVersion9) {
        return (
            <header id="header" className="hidden-xs">
                <div className="navbar-myob-header">
                    <div className="container">
                        <div className="navbar-brand">
                            <div id="MYOBLogo-desc" className="svg-logo">
                                {ieVersion9 && <img src={require('../../assets/img/logo-gradient.png').default} />}
                                <div className="IE10logo">
                                    <img src={require('../../assets/img/logo-gradient.png').default} />
                                </div>
                                <img src={require('../../assets/img/logo.svg').default} />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }

    renderMobileHeaderTop() {
        const publicUrl = process.env.REACT_APP_REDIRECT_URL ? process.env.REACT_APP_REDIRECT_URL : '';
        const hrefLink = publicUrl + '/privacy'
        return (
            <header id="mobile-header" className="hidden-lg hidden-sm hidden-md">
                <div>
                    <div className="myob">
                        <span className='power-by'>Powered by</span>
                        <img src={require('../../assets/img/logo-gradient.png')} width="60px"/>
                    </div>
                    <div className="privacy">
                        <a href={hrefLink}>Privacy</a>
                    </div>
                </div>
            </header>
        );
    }

    renderInvoiceListHeader() {
        if (!this.props.showListPage) return null;
        const { invoiceList, isStatement, isPaymentPage, totalDue } = this.props;
        const total = parseFloat(totalDue.toFixed(2));
        const tipMessage = 'Once you\'ve paid, invoice statuses may take a few days to update.';
        return (
            <div className="invoice_header">
                <div className="container">
                    <div className="row">
                        <div
                            className={'header_info ' + 'clearfix ' + (this.props.isPaymentPage ? '' : 'invoice-list-title')}>
                            <div className="row">
                                <div className="invoice_list_header">
                                    <div className="info_col">
                                        <h1 id="invoice_list_header">
                                            {isStatement && <span className="statementListHeader">
                      Unpaid invoices sent from {invoiceList.companyName} to {invoiceList.customerName}
                    </span>}
                                            {!isStatement && <span className="statementListHeader">
                      Unpaid invoices sent from {invoiceList.companyName} to {invoiceList.customerEmail}
                    </span>}
                                        </h1>
                                    </div>
                                    <div
                                        className={isPaymentPage ? 'invoice_list_sub_header_details_payment' : 'invoice_list_sub_header_details_v2'}>
                                        {isStatement && <h4>
                                          <p>
                                            <em>This is a list of unpaid invoices sent
                                              to {invoiceList.customerName}.<br /></em>
                                            <em>{tipMessage}</em>
                                          </p>
                                        </h4>}
                                        {!isStatement &&
                                          <h4>
                                            <p>
                                              <em>This is a list of unpaid invoices sent to this specific email
                                                address {invoiceList.customerEmail}.<br /></em>
                                              <em>{tipMessage}</em>
                                            </p>
                                          </h4>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={!isPaymentPage ? 'invoice_header_total_amount_payment_mobile' : ''}>
                            <div
                                id="paymentHeader"
                                className={['header_value', 'clearfix', !isPaymentPage ? 'invoice_list_header_total' : ''].join(' ')}>
                                <ul>
                                    <li className="invoice_amount"><sup
                                        className="dollar">$</sup>{dollarNumber(total)}<sup>{centNumber(total)}<sub>{
                                        invoiceList.invoiceListCurrency}</sub></sup></li>
                                    {!isPaymentPage && <li className="invoice_status_total_due">TOTAL DUE</li>}
                                    {isPaymentPage &&
                                      <li className="invoice_status_pay_invoice">PAY {this.props.invoicesToPay} INVOICE
                                          {this.props.invoicesToPay && this.props.invoicesToPay > 1 && <span>S</span>}
                                      </li>}
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}


